module.exports = __webpack_public_path__ + "static/media/scene_one.63e40d11.png";